import request from '../libs/request';
import dateFormat from 'date-fns/format';
import saveAs from 'file-saver';

const res = 'Process';

export default {
  async exportFile(ids) {
    const result = await request({
      url: `api/${res}/exportFile`,
      method: 'post',
      responseType: 'blob',
      data: {
        ids
      }
    });

    const blob = new Blob([result], {
      type: 'application/octet-stream'
    });
    saveAs(blob, 'Process-' + dateFormat(new Date(), 'yyyyMMddHHmmss') + '.proc');
  }
};
